import {useEffect} from "react";
import {useNavigate} from "react-router-dom";

import {
  SESSION_ENDED_PARAM,
  SESSION_ENDED_REASON_PARAM,
} from "@/src/modules/auth/lib/session-ended-copy";
import {useSessionEndStore} from "@/src/modules/auth/store/session-end";

export function useSessionEndRedirect(): void {
  const navigate = useNavigate();
  const endedReason = useSessionEndStore((s) => s.endedReason);
  const setEndedReason = useSessionEndStore((s) => s.setEndedReason);

  useEffect(() => {
    if (!endedReason) {
      return;
    }

    const params = new URLSearchParams({
      [SESSION_ENDED_PARAM]: "1",
      [SESSION_ENDED_REASON_PARAM]: endedReason,
    });
    navigate(`/login?${params.toString()}`, {replace: true});
    setEndedReason(null);
  }, [endedReason, navigate, setEndedReason]);
}
